<template>
<div>
    <v-head :title="title"></v-head>
    <p class="warmTip" v-show="warmTip">没有数据了～</p>
    <div class="loadingTip"><van-loading size="24px" v-show="loading" type="spinner">加载中...</van-loading></div>
    <div class="dialog-body-content-base-style" style="justify-content: center; align-items: center">
        <pdf
                :src="url"
                :page="currentPage"
                @num-pages="pageCount=$event"
                @page-loaded="currentPage=$event"
                @loaded="loadPdfHandler"
                style="width: 100%"></pdf>
        <p class="arrow">
            <van-button type="default" @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}">上一页</van-button>
            <span>{{currentPage}} / {{pageCount}}</span>
            <van-button @click="changePdfPage(1)" class="turn" :class="{grey: currentPage==pageCount}">下一页</van-button>
        </p>
        <div class="arrowfont">
          <span>*提示：放大浏览，请点击右上角选择浏览器中打开</span>
        </div>
    </div>
</div>
</template>

<script>
import {Button,Loading } from 'vant';
import {showPdf} from "@/api/dictionary";
import pdf from 'vue-pdf';
import vHead from "../../components/Subhead.vue";
import {} from "@/utils/sessionStorage.js"
export default {
  data() {
    return {
        url:'',
        enclosureId:'',
        title:"资源详情",
        currentPage: 0, // pdf文件页码
        pageCount: 0, // pdf文件总页数
        showPdfUrl:showPdf,
        warmTip:false,
        loading:true,
    };
  },
  filters: {
    
  },
  components: {
      pdf,
      vHead,
      [Button.name]: Button,
      [Loading.name]:Loading ,
  },
  methods: {
    // pdf加载时
    loadPdfHandler (e) {
        this.currentPage = 1; // 加载的时候先加载第一页
        console.log(this.currentPage)
        if(this.currentPage!=0){
            this.loading= false
        }
    },
   changePdfPage (val) {
      if (val === 0 && this.currentPage > 1) {
          this.currentPage--
      }
      if (val === 1 && this.currentPage < this.pageCount) {
          this.currentPage++
      }
   }
  },
  computed: {
    pdfUrl(){
        return this.$route.query&&this.$route.query.url;
    },
  },
  watch:{
	
  },
  mounted() {
      let pdfUrl = this.showPdfUrl+this.pdfUrl;
      this.url=pdfUrl;
    //   console.log(this.$route.query.url)
    //   console.log(this.currentPage)
      if(this.$route.query.url == null){
        this.warmTip = true;
        this.loading = false;
      }
  }

}
</script>

<style scoped>
.arrow{ text-align: center;}
.arrow>span{ margin: 0 30px;font-size: 14px;}
.warmTip{ font-size: 14px; margin-top:80px; margin-bottom: -160px; text-align: center}
.loadingTip{ font-size: 14px; margin-top:80px; margin-bottom: -100px; text-align: center}
/deep/.van-button{min-width: 36px;height: 40px;font-size: 14px;}
/deep/.van-button span{ margin: 0 20px;}
.arrowfont{ margin-top: 10px; text-align: center;}
</style>